import React from 'react'

const initialState = {
  modal: false,
  mobileMenu: false,
  cart: false,
  pageTransition: 'fade',
  toggleModal: () => { },
  toggleMobileMenu: () => { },
  setPageTransition: () => { },
  toggleCart: () => { },
  setDarkMode: () => {},
  darkMode: false,
  holiday: false
}

/*
HOLIDAYS
December 31 - New Years Eve
January 1 - New Years Day
December 25 - christmas
July 4 - July 4
October 31 - Halloween
February 14 - Valentines days
March 17 - St Patricks
April 22 - earth day
*/

export const AppContext = React.createContext(initialState)

class AppState extends React.Component {
  constructor (props) {
    super(props)
    this.state = initialState
  }

  componentDidMount () {
    if (window) {
      const darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches
      this.setDarkMode(darkMode)
      
      // var r = document.querySelector(':root');
      // const screenHeight = window.innerHeight + 'px'
      // r.style.setProperty('--initial-screen-height', screenHeight);
    }
  }

  // componentWillUnmount () {
  //   document.removeEventListener('keydown', this.escFunction, false)
  // }

  // escFunction = e => {
  //   if (e && e.keyCode === 27) { // escape key maps to keycode `27`
  //     this.toggleCart()
  //   }
  // }

  setDarkMode = mode => {
    var r = document.querySelector(':root');
    this.setState({ darkMode: mode });
		if (mode) {
			r.style.setProperty('--bg-color', 'var(--black)');
			r.style.setProperty('--text-color', 'var(--white)');
			r.style.setProperty('--default-bubble', '#333');
		} else {
      if ('valentinesDay' === true) {
        // Valentines
        r.style.setProperty('--bg-color', '#FFE5E3');
      } else if ('Halloween' === true) {
        // Halloween
        r.style.setProperty('--bg-color', 'var(--white)');
        r.style.setProperty('--override-bubble', '#F18A11');
      } else {
			  r.style.setProperty('--bg-color', 'var(--white)');
      }
			r.style.setProperty('--text-color', 'var(--black)');
			r.style.setProperty('--default-bubble', 'var(--black)');
		}
  }

  toggleMobileMenu = () => {
    const { mobileMenu } = this.state
    if (!mobileMenu) this.setState({ mobileMenu: true })
    else this.setState({ mobileMenu: false })
  }

  toggleModal = id => {
    if (id) {
      this.setState({ modal: id })
    } else {
      this.setState({ modal: false })
    }
  }

  setPageTransition = type => {
    if (type && this.state.pageTransition !== type) {
      this.setState({ pageTransition: type })
    }
  }

  toggleCart = () => {
    const { cart } = this.state
    if (!cart) this.setState({ cart: true })
    else this.setState({ cart: false })
  }

  render () {
    const { children } = this.props
    return (
      <AppContext.Provider
        value={{
          ...this.state,
          toggleMobileMenu: this.toggleMobileMenu,
          toggleModal: this.toggleModal,
          setPageTransition: this.setPageTransition,
          toggleCart: this.toggleCart,
          setDarkMode: this.setDarkMode
        }}
      >
        {children}
      </AppContext.Provider>
    )
  }
}

export const withAppState = Component => props => (
  <AppContext.Consumer>
    {context => (
      <Component {...props}
        appContext={context}
      />
    )}
  </AppContext.Consumer>
)

export default AppState
